import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronLeft = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m14 6.708-6 6 6 6'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.47 6.178a.75.75 0 1 1 1.06 1.06l-5.47 5.47 5.47 5.47.052.056a.75.75 0 0 1-1.056 1.056l-.056-.052-6-6a.75.75 0 0 1 0-1.06z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
